<template lang="pug">
  div(class="text-xs-center preloader")
    v-layout(row justify-center align-center fill-height)
      v-progress-circular(:size="50" color="primary" indeterminate)
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<style lang="scss" scoped>
.preloader {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 1;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Preloader/Preloader.vue